/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCategoryTagsResponse } from '../../models/company-category-tags-response';

export interface GetCompanyCategoryTags$Params {
  id: number;
}

export function getCompanyCategoryTags(http: HttpClient, rootUrl: string, params: GetCompanyCategoryTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCategoryTagsResponse>>> {
  const rb = new RequestBuilder(rootUrl, getCompanyCategoryTags.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyCategoryTagsResponse>>;
    })
  );
}

getCompanyCategoryTags.PATH = '/api/company-categories/{id}/tags';
